import { ICountryDictionaryAccepted } from '../../../actions/userObject/settings/countryDictionary'
import { IUserObjectStore } from '../index'

export default function(
  state: IUserObjectStore,
  action: ICountryDictionaryAccepted,
): IUserObjectStore {
  return {
    ...state,
    countryDictionary: action.dictionary,
  }
}
